import React from "react";
import CLoader from "./CLoader";

const CLoaderOverLay = () => {
  return (
    <div
      className=" fixed top-0 right-0 left-0 bottom-0  bg-white"
      style={{ zIndex: 10000 }}
    >
      <CLoader />
    </div>
  );
};

export default CLoaderOverLay;
